import React from "react";
import { UseFormReturn } from "react-hook-form";
import { Input, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";

interface IGroupForm {
  loading: boolean;
  form: UseFormReturn<any, any>;
  submit: any;
}

export const GroupForm: React.FC<IGroupForm> = ({ loading, form, submit }) => {
  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3">
        <Input
          label="Nom"
          className="w-full"
          {...form.register("name", { required: "Nom requis" })}
        />
        <Input label="Siren" className="w-full" {...form.register("siren")} />
        <Textarea label="Notes" className="w-full" {...form.register("notes", { required: true })} />
      </div>

      <div className="w-full mt-4">
        <Button onClick={submit} loading={loading} disabled={loading}>
          Valider
        </Button>
      </div>
    </div>
  );
};
